module.exports = __webpack_public_path__ + "static/decoracion.1707544c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/inicio-soluciones/decoracion.jpg
// module id = 356
// module chunks = 35783957827783